import { CalendarToday } from '@material-ui/icons';
import { makeStyles, Popover } from "@material-ui/core";
import React, { useRef, useState } from 'react';
import RangeDatePicker from '../RangeDataPicker/RangeDataPicker';
import { onlyDateFormatter } from '../../utils/utils';

const useStyles = makeStyles(theme => ({
    dateField: {
        gap: '.25rem',
        display: 'inline-flex',
        alignItems: 'center',
        background: 'white',
        padding: '.25rem',
        fontSize: '.85rem',
        lineHeight: '0',
        borderRadius: '.25rem',
        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
        border: '1px solid rgb(0 0 0 / .1)',
    },
}));

const DateRangeField = ({ range, onChange, className }) => {
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const anchorEl = useRef();
    const styles = useStyles();
    return <>
        <button ref={anchorEl}
            onClick={() => {
                setIsCalendarOpen(true);
            }} className={[styles.dateField, "unstyledButton", className].join(" ")}>
            {range?.[0] && range?.[1] &&
                <>
                    <strong>
                        {range?.[0] ? onlyDateFormatter.format(range[0]) : ""}
                    </strong>
                    -
                    <strong>
                        {range?.[1] ? onlyDateFormatter.format(range[1]) : ""}
                    </strong>
                </>
            }
            <CalendarToday />
        </button>
        <Popover
            open={isCalendarOpen}
            anchorEl={anchorEl.current}
            onClose={() => {
                setIsCalendarOpen(false);
            }}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            <RangeDatePicker range={range} onChange={onChange} />
        </Popover>
    </>;
};
export default DateRangeField;